<div class="flex flex-col w-full h-full">
  <app-breadcrumb class="mb-2" [items]="breadcrumdItems" />

  <h1 class="mb-8 text-light-300 text-3xl font-medium">
    Tier <span class="text-xl text-red-100">(Demo Mode)</span>
  </h1>

  <div class="flex flex-col lg:flex-row gap-8 pb-8">
    <div class="basis-1/2">
      @if((_rewardsService.isRewardsLoading$ | async )&&(
      _rewardsService.isInvestmentTiresLoading$ | async)) {
      <ng-container *ngTemplateOutlet="loadingInvestementAmountSkeleton" />
      } @else {
      <div
        class="flex flex-col gap-4 w-full bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150"
      >
        <p class="font-bold text-xl text-light-300">
          @switch (rewards?.currentInvestementTire) {
          <!--  -->
          @case (InvestementTireType.INTRO) {Intro}
          <!--  -->
          @case (InvestementTireType.PLUS) {Plus}
          <!--  -->
          @case (InvestementTireType.ELITE) {Elite}
          <!--  -->
          }
        </p>

        <div>
          <div class="flex flex-row items-baseline justify-between mb-1">
            <p class="font-bold text-xl text-light-200">
              {{
                rewards?.investedIntheLast12Months | customCurrency : currency
              }}
            </p>
            <p class="text-sm text-light-200">Invested in the last 12 months</p>
          </div>

          @if (nextTier) {
          <p-progressbar
            [style]="{ height: '8px' }"
            [value]="rewards?.investedIntheLast12MonthsPercentage"
            [showValue]="false"
          />
          }
        </div>

        @if (nextTier) {
        <p class="text-sm text-light-200 text-center">
          Invest
          <span class="font-bold">
            {{ currency }}
            {{ investAmountToReachNextTier | number : "1.2-2" }}
          </span>
          to reach
          <span class="font-bold">
            {{ nextTier }}
          </span>
          tier
        </p>
        }
      </div>
      }
    </div>

    <div class="basis-1/2">
      @if(_rewardsService.isInvestmentTiresLoading$ |async){
      <ng-container *ngTemplateOutlet="loadingInvestementTiersSkeleton" />
      } @else {
      <div
        class="flex flex-col gap-4 w-full bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150"
      >
        <app-timeline [timeline]="rewardsTimeline" />
      </div>
      }
    </div>
  </div>
</div>

<ng-template #loadingInvestementAmountSkeleton>
  <a
    class="flex flex-col gap-4 w-full cursor-pointer bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150"
  >
    <p-skeleton width="100%" height="28px" />
    <p-skeleton width="100%" height="40px" />
    <p-skeleton width="60%" height="20px" styleClass="mx-auto" />
  </a>
</ng-template>

<ng-template #loadingInvestementTiersSkeleton>
  <div
    class="flex flex-col gap-4 w-full bg-light-0 p-6 rounded-lg border-[1.5px] border-light-150"
  >
    <p-skeleton width="100%" height="60px" />
    <p-skeleton width="100%" height="80px" />
    <p-skeleton width="100%" height="70px" />
  </div>
</ng-template>
